export default "__VITE_ASSET__m2Myz3oB__"